import * as ModuleClass from './../../_function/class.js';

var section_center_toggle_checkbox = document.getElementById("section_center_toggle_checkbox");

function updateSectionsCentered() {
  let sections = document.getElementsByTagName('section');
  // for ( var i = 0; i < sections.length; i++ ) {
  //   sections[ i ]
  // }
  if (section_center_toggle_checkbox.checked)
  {
    ModuleClass.addClass( sections, 'section--center' );
  }
  else
  {
    ModuleClass.removeClass( sections, 'section--center' );
  }
}

if (section_center_toggle_checkbox != null) {
  section_center_toggle_checkbox.addEventListener('click', updateSectionsCentered);
}

updateSectionsCentered();
